import React from 'react';
import {HREF_PAGE_ADD_CLINIC, USER_TYPE_MEDIC} from "../../models/constants";
import locales_es from "../../locales/es";
import AuthService from "../../modules/authService";

const NoAttentionPlaces = ({medicId}) => {
  const auth = new AuthService();
  return (
    <div className="kt-portlet p-3">
      <div className="alert alert-warning fade show mt-3" role="alert">
        <div className="alert-icon"><i className="flaticon-warning"></i></div>
        <div className="alert-text">No tienes lugares de atención. Ingresa al menos uno para configurar tus
          turnos.
        </div>
      </div>
      {auth.getLocalUserType() === USER_TYPE_MEDIC &&
        <div className="text-center">
          <a href={`${HREF_PAGE_ADD_CLINIC}/${medicId}?redirect=${window.location.pathname}`}
             className="btn btn-brand btn-sm btn-bold btn-upper">+ {locales_es.addClinic}</a>
        </div>
      }
    </div>
  );
};

export default NoAttentionPlaces;
